import {
  AuctionResource,
  CarResource,
  CategoryResource,
  ColorsResource,
  DashboardResource,
  ManufactureResource,
  MaterialResource,
  MeasureResource,
  NotificationResource,
  PaymentResource,
  PromotionResource,
  SettingsResource,
  SupportResource,
  TypeFuelResource,
  UserResource,
  VipResource,
  WhatsappResource
} from "./resource";

import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);

export default {
  startLoader: function () {
    if (this.loader) {
      this.loader.hide();
    }

    this.loader = Vue.$loading.show({
      // Pass props by their camelCased names
      canCancel: true, // default false
      color: "#000000",
      loader: "spinner",
      width: 64,
      height: 64,
      backgroundColor: "#ffffff",
      opacity: 0.5,
      zIndex: 999,
    });
  },
  stopLoader: function () {
    this.loader.hide();
  },
  // UTIL
  isExpired: function (oldDate) {
    oldDate = new Date(oldDate);
    let newDate = new Date();
    oldDate.setSeconds(oldDate.getSeconds() + 30); // limit 30 sec
    return oldDate < newDate;
  },
  //DASHBOARD
  getDashboardList: function (q) {
    return DashboardResource.get({
      Q: q,
    });
  },
  getDashboard: function () {
    return DashboardResource.get({});
  },

  // USER
  login: function (data) {
    return UserResource.save(
      {
        PATH: "login",
      },
      data
    );
  },
  reset: function (data) {
    return UserResource.save(
      {
        PATH: "reset",
      },
      data
    );
  },
  getUserList: function (q) {
    return UserResource.get({
      Q: q,
    });
  },
  getUser: function (id) {
    return UserResource.get({
      ID: id,
    });
  },
  getVipList: function (q) {
    return VipResource.get({
      Q: q,
    });
  },
  createVip: function (data) {
    return VipResource.save({}, data);
  },
  deleteVip: function (id) {
    return VipResource.delete({ ID: id });
  },

  getMe: function () {
    return UserResource.get({
      PATH: "me",
    });
  },
  createUser: function (data) {
    return UserResource.save(
      {
        // PATH: ["app", "register"]
      },
      data
    );
  },
  updateUser: function (data) {
    return UserResource.update(
      {
        PATH: "",
      },
      data
    );
  },
  deleteUser: function (data) {
    return UserResource.delete({
      ID: data.id,
    });
  },
  updatePassword: function (data) {
    return UserResource.update(
      {
        PATH: "password",
      },
      data
    );
  },
  createAddress: function (data) {
    return UserResource.save(
      {
        PATH: "address",
      },
      data
    );
  },
  updateAddress: function (data) {
    return UserResource.update(
      {
        PATH: "address",
      },
      data
    );
  },
  deleteAddress: function (data) {
    return UserResource.delete({
      PATH: "address",
      ID: data.id,
    });
  },
  getCepAddress: function (id) {
    return UserResource.get({
      PATH: ["address", "cep"],
      ID: id,
    });
  },

  //PENDING USER

  getUserToValidateList: function (q) {
    return UserResource.get({
      PATH: "pending",
      Q: q,
    });
  },

  //APPROVE
  approveUser: function (data) {
    return UserResource.save(
      {
        PATH: "approve",
      },
      data
    );
  },

  //REPROVE
  reproveUser: function (data) {
    return UserResource.save(
      {
        PATH: "reprove",
      },
      data
    );
  },

  //AUCTION
  getAuctionList: function (q) {
    return AuctionResource.get({
      Q: q,
    });
  },
  getAuction: function (id) {
    return AuctionResource.get({
      ID: id,
    });
  },
  createAuction: function (data) {
    return AuctionResource.save({}, data);
  },
  updateAuction: function (data) {
    return AuctionResource.update({}, data);
  },
  deleteAuction: function (data) {
    return AuctionResource.delete({
      ID: data.id,
    });
  },

  //PROMOTION
  getPromotionList: function (q) {
    return PromotionResource.get({
      Q: q,
    });
  },
  getPromotion: function (id) {
    return PromotionResource.get({
      ID: id,
    });
  },
  createPromotion: function (data) {
    return PromotionResource.save({}, data);
  },
  updatePromotion: function (data) {
    return PromotionResource.update({}, data);
  },
  deletePromotion: function (data) {
    return PromotionResource.delete({
      ID: data.id,
    });
  },

  //PAYMENT
  getPaymentList: function (q) {
    return PaymentResource.get({
      Q: q,
    });
  },
  getPayment: function (id) {
    return PaymentResource.get({
      ID: id,
    });
  },
  createPayment: function (data) {
    return PaymentResource.save({}, data);
  },
  updatePayment: function (data) {
    return PaymentResource.update({}, data);
  },
  deletePayment: function (data) {
    return PaymentResource.delete({
      ID: data.id,
    });
  },

  //MATERIAL
  getMaterialList: function (q) {
    return MaterialResource.get({
      Q: q,
    });
  },
  getMaterial: function (id) {
    return MaterialResource.get({
      ID: id,
    });
  },
  createMaterial: function (data) {
    return MaterialResource.save({}, data);
  },
  updateMaterial: function (data) {
    return MaterialResource.update({}, data);
  },
  deleteMaterial: function (data) {
    return MaterialResource.delete({
      ID: data.id,
    });
  },

  //Category
  getCategoryList: function (q) {
    return CategoryResource.get({
      Q: q,
    });
  },
  getCategory: function (id) {
    return CategoryResource.get({
      ID: id,
    });
  },
  createCategory: function (data) {
    return CategoryResource.save({}, data);
  },
  updateCategory: function (data) {
    console.log(data);
    return CategoryResource.update({}, data);
  },
  deleteCategory: function (data) {
    return CategoryResource.delete({
      ID: data.id,
    });
  },

  //TypeFuel
  getTypeFuelList: function (q) {
    return TypeFuelResource.get({
      Q: q,
    });
  },
  getTypeFuel: function (id) {
    return TypeFuelResource.get({
      ID: id,
    });
  },
  createTypeFuel: function (data) {
    return TypeFuelResource.save({}, data);
  },
  updateTypeFuel: function (data) {
    return TypeFuelResource.update({}, data);
  },
  deleteTypeFuel: function (data) {
    return TypeFuelResource.delete({
      ID: data.id,
    });
  },

  //Colors
  getColorsList: function (q) {
    return ColorsResource.get({
      Q: q,
    });
  },
  getColors: function (id) {
    return ColorsResource.get({
      ID: id,
    });
  },
  createColors: function (data) {
    return ColorsResource.save({}, data);
  },
  updateColors: function (data) {
    return ColorsResource.update({}, data);
  },
  deleteColors: function (data) {
    return ColorsResource.delete({
      ID: data.id,
    });
  },

  //Manufacture
  getManufactureList: function (q) {
    return ManufactureResource.get({
      Q: q,
    });
  },
  getManufacture: function (id) {
    return ManufactureResource.get({
      ID: id,
    });
  },
  createManufacture: function (data) {
    return ManufactureResource.save({}, data);
  },
  updateManufacture: function (data) {
    return ManufactureResource.update({}, data);
  },
  deleteManufacture: function (data) {
    return ManufactureResource.delete({
      ID: data.id,
    });
  },

  //MEASURE
  getMeasureList: function (q) {
    return MeasureResource.get({
      Q: q,
    });
  },
  getMeasure: function (id) {
    return MeasureResource.get({
      ID: id,
    });
  },
  createMeasure: function (data) {
    return MeasureResource.save({}, data);
  },
  updateMeasure: function (data) {
    return MeasureResource.update({}, data);
  },
  deleteMeasure: function (data) {
    return MeasureResource.delete({
      ID: data.id,
    });
  },

  //Car
  getCarList: function (q) {
    return CarResource.get({
      PATH: "list",
      Q: q,
    });
  },
  getCar: function (id) {
    return CarResource.get({
      ID: id,
    });
  },
  createCar: function (data) {
    return CarResource.save({}, data);
  },
  updateCar: function (data) {
    return CarResource.update({
      PATH: "edit",
    }, data);
  },
  deleteCar: function (data) {
    return CarResource.delete({
      ID: data.id,
    });
  },

  deleteCarImage: function (data) {
    return CarResource.delete({
      PATH: "image",
      ID: data.id,
    });
  },

  getSaleCarList: function (q) {
    return CarResource.get({
      PATH: "mark",
      Q: q,
    });
  },

  createCareasure: function (data) {
    return CarResource.save(
      {
        PATH: "measure",
      },
      data
    );
  },
  updateCarMeasure: function (data) {
    return CarResource.update(
      {
        PATH: "measure",
      },
      data
    );
  },
  deleteCarMeasure: function (data) {
    return CarResource.delete({
      PATH: "measure",
      ID: data.id,
    });
  },

  //PENDING Car

  getCarToValidateList: function (q) {
    return CarResource.get({
      PATH: "pending",
      Q: q,
    });
  },

  //APPROVE
  approveCar: function (data) {
    return CarResource.save(
      {
        PATH: "approve",
      },
      data
    );
  },

  //REPROVE
  reproveCar: function (data) {
    return CarResource.save(
      {
        PATH: "reprove",
      },
      data
    );
  },

  //SUPPORT
  getSupportList: function (q) {
    return SupportResource.get({
      Q: q,
    });
  },
  getSupport: function (id) {
    return SupportResource.get({
      ID: id,
    });
  },
  createSupport: function (data) {
    return SupportResource.save({}, data);
  },
  updateSupport: function (data) {
    return SupportResource.update({}, data);
  },
  deleteSupport: function (data) {
    return SupportResource.delete({
      ID: data.id,
    });
  },

  //NOTIFICATION
  getNotificationsList: function (q) {
    return NotificationResource.get({
      Q: q,
    });
  },
  createNotification: function (data) {
    return NotificationResource.save({}, data);
  },
  deleteNotification: function (data) {
    return NotificationResource.delete({
      ID: data.id,
    });
  },

  //SETTINGS
  getSettings: function () {
    return SettingsResource.get({});
  },
  updateSettings: function (data) {
    return SettingsResource.update(data);
  },

  //WhatsApp
  refreshQRCode: function () {
    return WhatsappResource.get({
      PATH: "qrcode",
    });
  },

  exitWhatsApp: function (q) {
    return WhatsappResource.get({
      PATH: "exit",
      Q: q
    });
  },

  forceWhatsApp: function (q) {
    return WhatsappResource.get({
      PATH: "force",
      Q: q,
    });
  },

};



// WEBPACK FOOTER //
// ./src/api/index.js